module.exports = __webpack_public_path__ + "img/V-63-ER-1000-BB.724f3d06.png";